import { memo } from 'react'
import { Container } from 'react-bootstrap'

import styles from './styles.module.scss'

const FCFooter = () => {
  // const { t } = useTranslation('footer')

  //
  //

  return (
    <Container className={styles['footer-container']}>
      <footer className={styles.footer}>Cyberdog © 2026</footer>
    </Container>
  )
}

export const Footer = memo(FCFooter)
